<template>
  <div class="lp-tooltip">
    <span
      ref="trigger"
      class="lp-tooltip-trigger"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <slot />
    </span>

    <teleport to="body">
      <transition :name="transition">
        <div
          v-show="!disabledValue && show"
          ref="popover"
          class="lp-tooltip-popper"
          :class="[placement && `lp-tooltip-${placement.split('-')[0]}`]"
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
        >
          <div class="lp-tooltip-content tooltip">
            <slot name="content">
              <div v-html="content" />
            </slot>
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { usePopover } from '@/hooks'
import { Positions } from '@/models/enums'

export default defineComponent({
  name: 'lp-tooltip',
  props: {
    content: [String, Number],
    disabled: Boolean,
    hoverable: Boolean,
    placement: {
      type: String,
      default: Positions.T,
      validator: (value: Positions) => Object.values(Positions).includes(value),
    },
    permanent: Boolean,
    autoposition: { type: Boolean, default: true },
  },
  setup(props) {
    const popover = ref(null)
    const trigger = ref(null)

    const {
      show,
      placement,
      disabled,
      clickable,
      transition,
      visionTimer,
      permanent,
      position,
      handleMouseEnter,
      handleMouseLeave,
      hidePopover,
      showPopover,
      setPopoverPosition,
    } = usePopover({
      ...props,
      popover,
      trigger,
      arrowCalculation: false,
      disableSetPosition: false,
    })

    onMounted(() => {
      if (permanent.value) {
        showPopover()
      }
    })

    return {
      show,
      placementValue: placement,
      disabledValue: disabled,
      clickable,
      transition,
      visionTimer,
      popover,
      trigger,
      position,
      handleMouseEnter,
      handleMouseLeave,
      hidePopover,
      showPopover,
      setPopoverPosition,
    }
  },
})
</script>
